
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/u/[username]",
      function () {
        return require("private-next-pages/u/[username].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/u/[username]"])
      });
    }
  